import React from "react";
import login from "../../Assets/brand/login.svg";

const EmailVerificationIllustration: React.FC = () => {
  return (
    <div className="max-w-md" id="email-verification-illustration-container">
      <img
        id="email-verification-illustration-image"
        src={login}
        alt="Email verification illustration"
        className="w-full h-auto"
      />
    </div>
  );
};

export default EmailVerificationIllustration;
